'use strict'

import api from './leadRealAPI'

let appConfig = {}
let defaultLang = window.location.pathname
if (defaultLang === '/') {
  defaultLang = '/ja'
}
let locale = defaultLang.replace(/^\/([^]+).*/i, '$1')
locale = locale.split('/')

if (locale[0] === 'administrator') {
  locale[0] = 'ja'
}

//
// If we have the "app-config" element, let's load its contents into our config object.
//
// if (document.getElementById('app-config')) {
// load the config options

const config = {
  plugins: [
    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview', 'anchor',
    'searchreplace', 'visualblocks', 'code', 'fullscreen',
    'insertdatetime', 'media', 'table', 'pagebreak'
  ],
  selector: 'textarea',
  language: 'ja',
  block_formats: 'Paragraph=p; Heading 3=h3; Heading 4=h4; Heading 5=h5; Heading 6=h6; Preformatted=pre',
  images_upload_handler: function uploadImage (blobInfo, progress) {
    return new Promise((resolve, reject) => {
      var formData

      const config = {
        onUploadProgress: progressEvent => progress(progressEvent.loaded / progressEvent.total * 100)
      }
      formData = new FormData()
      formData.append('file', blobInfo.blob(), blobInfo.filename())
      api
        .post('/admin/uploadImages', formData, config, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(response => {
          resolve(response.data.url)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  menubar: 'file edit view insert format tools table tc help',
  toolbar:
  'undo redo | bold italic underline strikethrough | fontfamily fontsize styles | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment',
  height: 400,
  relative_urls: false,
  convert_urls: false,
  remove_script_host: false,
  link_assume_external_targets: true,
  setup: function (editor) {
    editor.on('change', function () {
      editor.save()
    })
    editor.ui.registry.addButton('paragraph', {
      text: '"',
      onAction: function (_) {
        editor.insertContent('"' + editor.selection.getContent({ format: 'text' }) + '"')
      }
    })
    editor.ui.registry.addButton('linkTag', {
      text: 'Link',
      onAction: function (_) {
        editor.focus()
        editor.selection.setContent('<a href="http://' + editor.selection.getContent() + '.com">' + editor.selection.getContent() + '</a>')
      }
    })
  },
  content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
}
appConfig = { api_key: process.env.VUE_APP_API_KEY, config: config }
// }

/**
 * Get a config option, using dot-syntax.
 *
 * Will parse the requested key by a period to look for nested attributes.
 *
 * For example, "tiny.key" would look for the "key" parameter inside a "tiny" object.
 *
 * @param key
 * @return {*}
 */
// appConfig.get = function (key) {
//   return key.split('.').reduce((o, i) => o[i], this)
// }

// freeze our object
Object.freeze(appConfig)

export default appConfig
